/**
 * Columns API
 *
 * API functions for board columns.
 */

import { api } from "./client";
import type { Column, ColumnId, UpdateColumnRequest } from "./types";

export async function updateColumn(
  id: ColumnId,
  request: UpdateColumnRequest,
): Promise<Column> {
  return api.patch<Column>(`/columns/${id}`, request);
}
